function productStickyAtcSizedImageUrl(src, width) {
  if (!src) return '';
  const absolute = src.startsWith('//') ? `https:${src}` : src;
  const join = absolute.includes('?') ? '&' : '?';
  return `${absolute}${join}width=${width}`;
}

function initProductStickyAtc(root) {
  const sectionId = root.dataset.sectionId;
  if (!sectionId) return;

  const sentinel = document.getElementById(`product-inline-atc-${sectionId}`);
  const mainQty = document.getElementById(`Quantity-${sectionId}`);
  const stickyQty = document.getElementById(`StickyQuantity-${sectionId}`);
  const mainBtn = document.getElementById(`ProductSubmitButton-${sectionId}`);
  const stickyBtn = root.querySelector('[data-sticky-atc-submit]');
  const stickyPrice = document.getElementById(`StickyPrice-${sectionId}`);
  const stickyImg = root.querySelector('.product-sticky-atc__image');

  if (!sentinel || !mainBtn || !stickyBtn) {
    root.remove();
    return;
  }

  let rafId = null;

  function updateVisibility() {
    const rect = sentinel.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const intersectsViewport = rect.top < vh && rect.bottom > 0;
    const scrolledPast = rect.bottom <= 0;
    const show = scrolledPast && !intersectsViewport;

    root.classList.toggle('product-sticky-atc--visible', show);
    root.toggleAttribute('hidden', !show);
    document.body.classList.toggle('product-sticky-atc--active', show);

    if (show) {
      document.body.style.setProperty('--product-sticky-atc-height', `${root.offsetHeight}px`);
      syncButtonFromMain();
      if (mainQty && stickyQty) syncMainToSticky();
    } else {
      document.body.style.removeProperty('--product-sticky-atc-height');
    }
  }

  function scheduleUpdate() {
    if (rafId != null) return;
    rafId = requestAnimationFrame(() => {
      rafId = null;
      updateVisibility();
    });
  }

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate);

  function copyQtyAttrs(from, to) {
    if (!from || !to) return;
    ['min', 'max', 'step'].forEach((attr) => {
      if (from.hasAttribute(attr)) to.setAttribute(attr, from.getAttribute(attr));
      else to.removeAttribute(attr);
    });
    ['data-cart-quantity', 'data-min', 'data-max'].forEach((attr) => {
      if (from.hasAttribute(attr)) to.setAttribute(attr, from.getAttribute(attr));
      else to.removeAttribute(attr);
    });
    to.value = from.value;
  }

  function syncMainToSticky() {
    if (!mainQty || !stickyQty) return;
    copyQtyAttrs(mainQty, stickyQty);
    const wrap = stickyQty.closest('quantity-input');
    if (wrap && typeof wrap.validateQtyRules === 'function') wrap.validateQtyRules();
  }

  function syncStickyToMain() {
    if (!mainQty || !stickyQty) return;
    mainQty.value = stickyQty.value;
    mainQty.dispatchEvent(new Event('change', { bubbles: true }));
  }

  if (mainQty && stickyQty) {
    mainQty.addEventListener('change', syncMainToSticky);
    mainQty.addEventListener('input', syncMainToSticky);
    stickyQty.addEventListener('change', syncStickyToMain);
  }

  stickyBtn.addEventListener('click', () => {
    if (mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true') return;
    if (mainQty && stickyQty) syncStickyToMain();
    mainBtn.click();
  });

  function syncButtonFromMain() {
    stickyBtn.disabled = mainBtn.disabled;
    const ariaDisabled = mainBtn.getAttribute('aria-disabled');
    if (ariaDisabled === 'true') stickyBtn.setAttribute('aria-disabled', 'true');
    else stickyBtn.removeAttribute('aria-disabled');
    stickyBtn.classList.toggle('loading', mainBtn.classList.contains('loading'));
    const mainSpan = mainBtn.querySelector('span');
    const stickySpan = stickyBtn.querySelector('span');
    if (mainSpan && stickySpan) stickySpan.textContent = mainSpan.textContent;
  }

  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (!event.data || event.data.sectionId !== sectionId) return;
      const html = event.data.html;
      if (html && stickyPrice) {
        const source = html.getElementById(`price-${sectionId}`);
        if (source) stickyPrice.innerHTML = source.innerHTML;
      }
      const variant = event.data.variant;
      if (variant && variant.featured_media && variant.featured_media.preview_image && stickyImg) {
        stickyImg.src = productStickyAtcSizedImageUrl(variant.featured_media.preview_image.src, 160);
        if (variant.featured_media.alt) stickyImg.alt = variant.featured_media.alt;
      }
      requestAnimationFrame(syncButtonFromMain);
    });

    subscribe(PUB_SUB_EVENTS.quantityUpdate, () => {
      syncMainToSticky();
    });
  }

  const btnObserver = new MutationObserver(syncButtonFromMain);
  btnObserver.observe(mainBtn, {
    attributes: true,
    attributeFilter: ['disabled', 'class', 'aria-disabled'],
    subtree: true,
    childList: true,
    characterData: true,
  });

  syncMainToSticky();
  syncButtonFromMain();
  scheduleUpdate();
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-sticky-atc[data-section-id]').forEach(initProductStickyAtc);
});
